import { admin_favoriteAPI } from '@/common/service/ApiList';
import ServiceExec from '@/common/utils/ServiceExec';
import store from '@/store';

export default {
  fetchFavStoreList: async ({ commit, getters }, payload) => {
    if (payload.page === 1) commit('resetStoreList');
    const page = getters['getStorePage'];
    const limit = getters['getStoreLimit'];
    const { totalPage } = getters['getStorePageInfo'];

    if (page > totalPage) return;

    const { status, data } = await ServiceExec.get(
      admin_favoriteAPI.store_list,
      {
        page,
        limit,
        ...payload
      }
    );

    if (data) {
      const { pageInfo, list } = data;
      commit('setStorePageInfo', pageInfo);
      commit('setStorePage', page + 1);
      commit('setStoreList', list ?? []);
      return list;
    }
  },
  fetchFavProductList: async ({ commit, state, getters }, payload) => {
    const { page, limit, pageInfo } = state.product;
    const { totalPage } = pageInfo;

    if (page > totalPage) return;

    const { status, data } = await ServiceExec.get(
      admin_favoriteAPI.product_list,
      {
        page,
        limit,
        ...payload
      }
    );
    const { list } = data;

    commit('setProductPageInfo', data.pageInfo);
    commit('setProductPage', page + 1);
    commit('setProductList', list ?? []);
  },

  getMyFavStores: async ({ commit, state }, payload) => {
    const { status, data } = await ServiceExec.get(
      admin_favoriteAPI.store_list,
      payload
    );

    const { pageInfo, list } = data;
    commit('initList');
    commit('setFavStoreList', list ?? []);
    return list;
  },
  getMyFavProducts: async ({ commit, state }, payload) => {
    commit('initList');
    const { status, data } = await ServiceExec.get(
      admin_favoriteAPI.product_list,
      payload
    );

    if (status === 200) {
      const { pageInfo, list } = data;
      commit('setFavProductList', list ?? []);
    }
  },
  like_store: async ({ commit, state }, payload) => {
    const { userNo, storeNo } = payload;
    const { status } = await ServiceExec.post(
      admin_favoriteAPI.like_store(userNo, storeNo)
    );

    return status === ServiceExec.status.OK;
  },
  like_product: async ({ commit, state }, payload) => {
    const { userNo, productNo } = payload;
    const { status, data } = await ServiceExec.post(
      admin_favoriteAPI.like_product(userNo, productNo)
    );

    return data;
  },
  hate_store: async ({ commit, state }, payload) => {
    const { userNo, storeNo } = payload;
    const { status } = await ServiceExec.delete(
      admin_favoriteAPI.hate_store(userNo, storeNo)
    );

    return status === ServiceExec.status.OK;
  },
  hate_product: async ({ commit, state }, payload) => {
    const { userNo, productNo } = payload;
    const { status, data } = await ServiceExec.delete(
      admin_favoriteAPI.hate_product(userNo, productNo)
    );

    return data;
  }
};
